import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { MenuWidgets } from '../components/MenuWidgets';
import { IMenuWidgetsEvents, IMenuWidgetsFields } from '../components/types';
import { MenuWidgetsEvents } from './events';
import { getCurrentMovieKey } from '../../../../store/current-video/selectors';
import { CaptionsSelectionPopupSelectors } from '../../../../store/captions-selection-popup/selectors';
import { getMainViewMode, isLoggedUser } from '../../../../store/general/selectors';
import { PhraseListSelectors } from '../../../../store/phrase-list/selectors';
import { EPhrasePopupType } from '../../../../store/phrase-list/types';
import { EMainMenuActive, EMainViewMode } from '../../../../store/general/types';
import { UrlUtil } from '../../../../../common/utils/url-util';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IMenuWidgetsFields => {
		let active;
			
		const mainViewMode = getMainViewMode(state);
		if (mainViewMode === EMainViewMode.DASHBOARD) {
			const route = UrlUtil.getRoute();
			const type = route && route.length && route.length > 1 && route[1];
			if (type === 'videoRecent') {
				active = EMainMenuActive.RECENTS;
			} else {
				active = EMainMenuActive.HOME;
			}
		} else if (mainViewMode === EMainViewMode.CONTENT_LIBRARY) {
			active = EMainMenuActive.CONTENT_LIBRARY;
		} else if (mainViewMode === EMainViewMode.MY_LIBRARY) {
			active = EMainMenuActive.MY_LIBRARY;
		}

		const isVideo = mainViewMode === EMainViewMode.DASHBOARD;
		const isHide = isVideo && (
			CaptionsSelectionPopupSelectors.isShow(state) || PhraseListSelectors.getPhrasePopup(state) === EPhrasePopupType.SAVED
		);

		const loggedUser = isLoggedUser(state);

		return {
			active,
			isHide,
			showRecents: loggedUser,
			mainViewMode,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IMenuWidgetsEvents => ({
	onShowHelp: () => dispatch(MenuWidgetsEvents.onShowHelp()),
	onClickContent: () => dispatch(MenuWidgetsEvents.onClickContent()),
	onClickMyLibrary: () => dispatch(MenuWidgetsEvents.onClickMyLibrary()),
	onClickRecent: () => dispatch(MenuWidgetsEvents.onClickRecent()),
	onClickSettings: () => dispatch(MenuWidgetsEvents.onClickSettings()),
	onCopyLinkVideo: () => dispatch(MenuWidgetsEvents.onCopyLinkVideo()),
	onCopyLinkPlaylist: () => dispatch(MenuWidgetsEvents.onCopyLinkPlaylist()),
}
);

export const MenuWidgetsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(MenuWidgets);

MenuWidgetsHOC.displayName = 'MenuWidgetsHOC';
